import React, { useRef, useState } from 'react';
import { Share2, Download, X } from 'lucide-react';
import { useApp } from '../context/AppContext';

const ShareStreak = ({ onClose }) => {
  const { userData } = useApp();
  const canvasRef = useRef(null);
  const [generated, setGenerated] = useState(false);

  const generateImage = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = 800;
    canvas.height = 800;

    // Background gradient
    const grad = ctx.createLinearGradient(0, 0, 800, 800);
    grad.addColorStop(0, '#3b82f6');
    grad.addColorStop(1, '#8b5cf6');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, 800, 800);

    // White card
    ctx.fillStyle = 'rgba(255,255,255,0.15)';
    roundRect(ctx, 60, 60, 680, 680, 40);

    // App name
    ctx.fillStyle = 'rgba(255,255,255,0.8)';
    ctx.font = 'bold 36px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('יומן גמילה', 400, 160);

    // Fire emoji area
    ctx.font = '120px Arial';
    ctx.fillText('🔥', 400, 330);

    // Streak number
    ctx.fillStyle = 'white';
    ctx.font = 'bold 160px Arial';
    ctx.fillText(userData.streak, 400, 500);

    // Label
    ctx.font = 'bold 40px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    ctx.fillText('ימים נקיים', 400, 570);

    // Best streak
    ctx.font = '28px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText(`🏆 שיא: ${userData.bestStreak} ימים`, 400, 640);

    // Tagline
    ctx.font = '24px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.fillText('כל יום נקי הוא ניצחון 💙', 400, 700);

    setGenerated(true);
  };

  const roundRect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
    ctx.fill();
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.download = `streak-${userData.streak}-days.png`;
    link.href = canvasRef.current.toDataURL();
    link.click();
  };

  const handleShare = async () => {
    try {
      const blob = await new Promise(r => canvasRef.current.toBlob(r));
      const file = new File([blob], 'streak.png', { type: 'image/png' });
      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'הרצף שלי ביומן גמילה',
          text: `🔥 ${userData.streak} ימים נקיים! כל יום נקי הוא ניצחון 💙`
        });
      } else {
        handleDownload();
      }
    } catch {}
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-5 w-full max-w-sm shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-stone-800">📸 שתף את הרצף שלך</h3>
          <button onClick={onClose}><X className="w-5 h-5 text-stone-500" /></button>
        </div>

        <canvas ref={canvasRef} className="w-full rounded-xl mb-4" style={{ display: generated ? 'block' : 'none' }} />

        {!generated ? (
          <button
            onClick={generateImage}
            className="w-full bg-brand-500 text-white py-3 rounded-xl font-bold hover:bg-brand-600 transition"
          >
            🎨 צור תמונה
          </button>
        ) : (
          <div className="flex gap-2">
            <button
              onClick={handleDownload}
              className="flex-1 flex items-center justify-center gap-2 bg-stone-100 text-stone-700 py-3 rounded-xl font-bold hover:bg-stone-200 transition"
            >
              <Download className="w-4 h-4" /> הורד
            </button>
            <button
              onClick={handleShare}
              className="flex-1 flex items-center justify-center gap-2 bg-brand-500 text-white py-3 rounded-xl font-bold hover:bg-brand-600 transition"
            >
              <Share2 className="w-4 h-4" /> שתף
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareStreak;
